module.exports = __webpack_public_path__ + "static/media/dsc.109fa6bf.png";